import { useEffect, useRef, useState } from "react";
import { useMobxStores } from "../stores/stores";
import {
  Button,
  Col,
  Input,
  Row,
  Select,
  Table,
  Tag,
  Tooltip,
  Grid,
  Card,
  Skeleton,
  Empty,
  Modal,
} from "antd";
import { keycloak } from "../utils/keycloak";
import { SearchOutlined } from "@ant-design/icons";
import ImageBackground from "../components/LearningGraphTool/ImageBackground";
import "./Catalogue.css";
import CreateUpdateCatalogueItem from "../components/catalogue/CreateUpdateCatalogueItem";
import CreateUpdateCatalogueItemPhone from "../components/catalogue/CreateUpdateCatalogueItemPhone";
import { observer } from "mobx-react";
import { EyeOutlined, LinkOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiOpenInNew } from "@mdi/js";
import { Pagination } from "antd";

const { useBreakpoint } = Grid;

function TruncatedText({ text, limit = 80 }) {
  const [expanded, setExpanded] = useState(false);

  if (!text) text = "N/A";

  const isLong = text.length > limit;
  const displayText = expanded ? text : text.slice(0, limit);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <span

      // className="catalogue-description-text"
      >
        {displayText}
        {isLong && !expanded && (
          <span
            className="more-btn"
            onClick={() => setExpanded(true)}
            style={{ color: "#1677ff", cursor: "pointer" }}
          >
            ... more
          </span>
        )}

        {expanded && (
          <span
            className="less-btn"
            onClick={() => setExpanded(false)}
            style={{ color: "#1677ff", cursor: "pointer", marginLeft: 6 }}
          >
            less
          </span>
        )}
      </span>
    </div>
  );
}

const Catalogue = () => {
  const [currentPage, setCurrentPage] = useState(1);
  // const [pageSize, setPageSize] = useState(10); // choose what you want

  // useEffect(() => {
  //   catalogueStore.GetCatalogueItems({ page: 1, page_size: pageSize });
  //   catalogueStore.GetUser();
  // }, [pageSize]);

  const screens = useBreakpoint();
  const { id } = useParams();

  // const isMobile = !screens.sm;
  const isMobile = !screens.lg;

  const size = () => {
    let size;
    if (screens.xxl) size = "28px";
    else if (screens.xl) size = "20px";
    else if (screens.lg) size = "16px";
    else size = "16px";
    return size;
  };

  const mdiIconSize = () => {
    let size;
    if (screens.xxl) size = 1.4;
    else if (screens.xl) size = 1;
    else if (screens.lg) size = 0.8;
    else if (screens.md) size = 0.8;
    else if (screens.sm) size = 0.8;
    else size = 1;
    return size;
  };

  const { catalogueStore } = useMobxStores();
  const [searchInput, setSearchInput] = useState("");
  const [selectedType, setSelectedType] = useState("All Types");

  const [selectedRows, setSelectedRows] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const timeout = useRef(null);

  useEffect(() => {
    if (keycloak.authenticated && searchParams.get("openCreate") === "true") {
      catalogueStore.setIsCatalogueModalOpen(true);
      navigate("/catalogue", { replace: true });
    }
  }, []);

  useEffect(() => {
    catalogueStore.GetCatalogueItems(currentPage);
    catalogueStore.GetUser();

    const path = location.pathname;

    // check if URL contains /catalogue/
    if (path.startsWith("/catalogue/")) {
      const afterCatalogue = path.split("/catalogue/")[1];

      // check if what comes after is a number
      if (/^\d+$/.test(afterCatalogue)) {
        navigate(`/catalogue/${afterCatalogue}`, {
          state: { backgroundLocation: { pathname: "/catalogue" } },
          replace: true,
        });
      }
    }
  }, []);

  const handleTypeChange = (value) => {
    setSelectedType(value);
    setSearchInput("");

    value === "All Types"
      ? catalogueStore.GetCatalogueItems()
      : catalogueStore.GetCatalogueByType(value);
  };

  const columns = [
    {
      title: "Title",
      responsive: ["lg", "sm", "md", "xs"],
      key: "Title",
      width: "20%",
      render: (record) => <p>{record.title}</p>,
    },
    {
      title: "Description",
      responsive: ["lg", "sm", "md", "xs"],
      key: "description",
      width: "22%",
      // align: "left",
      render: (record) => (
        <TruncatedText text={record.description} limit={80} />
      ),

      // render: (record) => {
      //   console.log(record.description);
      //   const text = record.description;
      //   const isLong = text.length > 80;

      //   return (
      //     <Tooltip title={text}>
      //       <div className="catalogue-description-text-wrapper">
      //         <p className="catalogue-description-text">{text}</p>
      //         {isLong && (
      //           <span
      //             className="more-btn"
      //             style={{ color: "#1677ff", cursor: "pointer" }}
      //           >
      //             ...more
      //           </span>
      //         )}
      //       </div>
      //     </Tooltip>
      //   );
      // },
    },
    {
      title: "Type",
      responsive: ["lg", "sm", "md", "xs"],
      key: "type",
      width: "15%",
      render: (record) => (
        <Tag
          color={
            record.type === "Marketplace Asset"
              ? "#000080"
              : record.type === "Software Repository"
                ? "#D01FDF"
                : "#2A93D3"
          }
          style={{ borderRadius: "10px", width: "140px", textAlign: "center" }}
        >
          {record.type}
        </Tag>
      ),
    },

    {
      title: "Learning Outcome",
      responsive: ["lg", "sm", "md", "xs"],
      key: "educationalOutcome",
      width: "20%",
      render: (record) => <div>{record?.educational_outcome}</div>,
    },
    {
      title: "Level",
      responsive: ["lg", "sm", "md", "xs"],
      key: "level",
      width: "13%",
      render: (record) => <div>{record?.level}</div>,
    },
    // {
    //   title: "Source",
    //   responsive: ["lg", "sm", "md", "xs"],
    //   key: "source",
    //   width: "auto",
    //   align: "left",
    //   render: (record) => (
    //     <LinkOutlined
    //       style={{ fontSize: "28px", color: "#D01FDF", cursor: "pointer" }}
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         navigate(`${record.source}`, {
    //           state: { backgroundLocation: location },
    //         });
    //       }}
    //     />
    //   ),
    // },
    {
      title: "",
      responsive: ["lg", "sm", "md", "xs"],
      key: "actions",
      width: "10%",

      render: (record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
          }}
        >
          <div
            style={{
              minWidth: "17px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon
              path={mdiOpenInNew}
              // size={mdiIconSize()}
              style={{
                // fontSize: size(),
                width: size(),
                height: size(),
                color: "#D01FDF",
                cursor: "pointer",
                marginRight: "6px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (keycloak.authenticated) {
                  window.location.href = `${record.source}`;
                } else {
                  Modal.confirm({
                    title: "Sign in required",
                    content:
                      "You are not allowed to perform this action. You need to sign in first.",
                    okText: "Sign in",
                    cancelText: "Cancel",
                    onOk: () =>
                      keycloak.login({ redirectUri: window.location.href }),
                  });
                }
              }}
            />
          </div>

          {/* <LinkOutlined
            style={{
              fontSize: size(),
              color: "#D01FDF",
              cursor: "pointer",
              marginRight: "6px",
            }}
            onClick={(e) => {
              e.stopPropagation();
              window.location.href = `${record.source}`;
            }}
          /> */}
          <EyeOutlined
            style={{ fontSize: size(), color: "#D01FDF", cursor: "pointer" }}
            onClick={(e) => {
              e.stopPropagation();
              if (keycloak.authenticated) {
                navigate(`/catalogue/${record.id}`, {
                  state: { backgroundLocation: location },
                });
              } else {
                Modal.confirm({
                  title: "Sign in required",
                  content:
                    "You are not allowed to perform this action. You need to sign in first.",
                  okText: "Sign in",
                  cancelText: "Cancel",
                  onOk: () =>
                    keycloak.login({ redirectUri: window.location.href }),
                });
              }
            }}
          />
        </div>
      ),
    },
  ];

  const catalogueTypeOptions = [
    {
      value: "Marketplace Asset",
      label: "Marketplace Asset",
    },
    {
      value: "Software Repository",
      label: "Software Repository",
    },
    {
      value: "MOOC",
      label: "MOOC",
    },
    {
      value: "All Types",
      label: "All Types",
    },
  ];

  const handleSearch = async (inputValue) => {
    if (inputValue !== "") {
      await catalogueStore.GetCatalogueByTitle(inputValue);
    } else {
      await catalogueStore.GetCatalogueItems(1);
    }
  };

  const debouncedSearch = (inputValue) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(() => handleSearch(inputValue), 300);
  };

  return (
    <>
      {isMobile ? (
        <div className="catalogue-wrapper">
          <Row style={{ alignItems: "end", marginBottom: "14px" }}>
            <Col span={24}>
              <div className="catalogue-title ">Catalogue</div>
              <div className="catalogue-heading " style={{ marginTop: "-4px" }}>
                Find everything XR2Learn has to offer!
              </div>
            </Col>
            <Col span={24} style={{ display: "flex", justifyContent: "end" }}>
              <Button
                className="add-catalogue-button"
                style={{ marginTop: "24px", marginBottom: "16px" }}
                onClick={() => {
                  if (keycloak.authenticated) {
                    catalogueStore.setIsCatalogueModalOpen(true);
                  } else {
                    Modal.confirm({
                      title: "Sign in required",
                      content:
                        "You are not allowed to perform this action. You need to sign in first.",
                      okText: "Sign in",
                      cancelText: "Cancel",
                      onOk: () =>
                        keycloak.login({
                          redirectUri:
                            window.location.origin +
                            "/catalogue?openCreate=true",
                        }),
                    });
                  }
                }}
              >
                Add item
              </Button>
            </Col>
          </Row>
          <Row
            gutter={16}
            // style={{
            //   // marginTop: "-40px",
            //   alignItems: "middle",
            //   justifyContent: "start",
            // }}
          >
            <Col span={12}>
              {" "}
              <Input
                style={{
                  // minWidth: "100px",
                  // width: "50%",
                  height: "36px",
                  // marginRight: "12px",
                  background: "rgba(215, 215, 215, 0.4)",
                  border: "0.2px solid rgba(255, 255, 255, 0.4)",
                  backdropFilter: "blur(15px)",
                  borderRadius: "9px",
                  marginBottom: "12px",
                }}
                value={searchInput}
                // className="catalogue-search"
                suffix={<SearchOutlined style={{ color: "#5F5F6BAB" }} />}
                // placeholder="Search by title or description"
                onChange={(e) => {
                  setSearchInput(e.target.value);
                  setSelectedType("All Types");
                  debouncedSearch(e.target.value);
                }}
              />
            </Col>
            <Col span={12}>
              {" "}
              <Select
                style={{
                  height: "36px",
                  fontSize: "14px",
                  // minWidth: "100px", width: "46%"
                }}
                value={selectedType}
                onChange={handleTypeChange}
                options={catalogueTypeOptions}
                className="catalogue-select"
              />
            </Col>
            {/* <Input
              style={{
                minWidth: "100px",
                width: "50%",
                height: "36px",
                marginRight: "12px",
                marginBottom: "12px",
              }}
              value={searchInput}
              className="catalogue-search"
              suffix={<SearchOutlined style={{ color: "#5F5F6BAB" }} />}
              // placeholder="Search by title or description"
              onChange={(e) => {
                setSearchInput(e.target.value);
                setSelectedType("All Types");
                debouncedSearch(e.target.value);
              }}
            />

            <Select
              style={{ height: "36px", minWidth: "100px", width: "46%" }}
              value={selectedType}
              onChange={handleTypeChange}
              options={catalogueTypeOptions}
              className="catalogue-select"
            /> */}
          </Row>

          <Row
            justify={
              catalogueStore.catalogueItems.length === 0 ? "center" : "start"
            }
            align={"middle"}
            style={{ width: "100%", margin: "auto" }}
          >
            {catalogueStore.catalogueItems.map((item, index) => {
              return (
                <Col justify={"center"} align={"middle"} xs={24}>
                  {index === 0 && catalogueStore.loadingLastItem ? (
                    <Card
                      className="loading-item-card-catalogue"
                      key={item.id}
                    ></Card>
                  ) : (
                    <Card
                      className="loading-item-card-catalogue"
                      style={{ marginTop: "12px" }}
                      key={item.id}
                    >
                      <Row
                        style={{
                          justifyContent: "start",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#000080",
                          }}
                        >
                          {item.title}
                        </div>
                      </Row>
                      <Row
                        style={{
                          justifyContent: "start",
                        }}
                      >
                        {" "}
                        <div style={{ fontSize: "14px" }}>{item.type}</div>
                      </Row>
                      <Row
                        style={{
                          marginTop: "14px",
                          fontSize: "14px",
                          alignItems: "middle",
                          justifyContent: "space-between",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#2A93D3",
                          }}
                        >
                          {item.owner_username}
                        </div>
                        <div>
                          {" "}
                          <LinkOutlined
                            style={{
                              fontSize: mdiIconSize(),
                              color: "#D01FDF",
                              cursor: "pointer",
                              marginRight: "6px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              window.location.href = `${item.source}`;
                            }}
                          />
                          <EyeOutlined
                            style={{
                              fontSize: size(),
                              color: "#D01FDF",
                              cursor: "pointer",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (keycloak.authenticated) {
                                navigate(`/catalogue/${item.id}`, {
                                  state: { backgroundLocation: location },
                                });
                              } else {
                                Modal.confirm({
                                  title: "Sign in required",
                                  content:
                                    "You are not allowed to perform this action. You need to sign in first.",
                                  okText: "Sign in",
                                  cancelText: "Cancel",
                                  onOk: () =>
                                    keycloak.login({
                                      redirectUri: window.location.href,
                                    }),
                                });
                              }
                            }}
                          />
                        </div>
                      </Row>
                    </Card>
                    // <ItemPreview item={item} />
                  )}
                </Col>
              );
            })}
            {catalogueStore.catalogueItems.length > 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 16,
                  marginBottom: 40,
                }}
              >
                <Pagination
                  current={currentPage}
                  pageSize={50}
                  total={catalogueStore.catalogueCount ?? 0}
                  showSizeChanger={false}
                  showQuickJumper={false}
                  onChange={(
                    page,

                    // nextPageSize
                  ) => {
                    setCurrentPage(page);
                    // setPageSize(nextPageSize);
                    catalogueStore.GetCatalogueItems(
                      page,
                      // page_size: nextPageSize,
                    );
                  }}
                />
              </div>
            )}
            {catalogueStore.catalogueItems.length === 0 && (
              <Empty description="No items found" />
            )}
          </Row>

          <CreateUpdateCatalogueItemPhone />
        </div>
      ) : (
        <div className="catalogue-wrapper">
          <ImageBackground />
          <Row style={{ alignItems: "end", marginBottom: "68px" }}>
            <Col span={16}>
              <div className="catalogue-title ">Catalogue</div>
              <div className="catalogue-heading ">
                Find everything XR2Learn has to offer!
              </div>
            </Col>
            <Col span={8} style={{ display: "flex", justifyContent: "end" }}>
              <Button
                className="add-catalogue-button"
                onClick={() => {
                  if (keycloak.authenticated) {
                    catalogueStore.setIsCatalogueModalOpen(true);
                  } else {
                    Modal.confirm({
                      title: "Sign in required",
                      content:
                        "You are not allowed to perform this action. You need to sign in first.",
                      okText: "Sign in",
                      cancelText: "Cancel",
                      onOk: () =>
                        keycloak.login({
                          redirectUri:
                            window.location.origin +
                            "/catalogue?openCreate=true",
                        }),
                    });
                  }
                }}
              >
                Add item
              </Button>
            </Col>
          </Row>
          <Row
            style={{
              // marginTop: "-40px",
              alignItems: "middle",
              justifyContent: "start",
            }}
          >
            <Input
              style={{
                minWidth: "350px",
                width: "37vw",
                marginRight: "12px",
                // marginBottom: "12px",
              }}
              value={searchInput}
              className="catalogue-search"
              suffix={<SearchOutlined style={{ color: "#5F5F6BAB" }} />}
              placeholder="Search by title or description"
              onChange={(e) => {
                setSearchInput(e.target.value);
                setSelectedType("All Types");
                debouncedSearch(e.target.value);
              }}
            />

            <Select
              style={{ width: "200px" }}
              value={selectedType}
              onChange={handleTypeChange}
              options={catalogueTypeOptions}
              className="catalogue-select"
            />
          </Row>
          <Table
            columns={columns}
            dataSource={catalogueStore.catalogueItems}
            className="catalogue-table"
            pagination={false}
            // scroll={{ y: 820 }}
            scroll={{ y: "calc(100vh - 320px)" }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 16,
              marginBottom: 40,
            }}
          >
            <Pagination
              current={currentPage}
              pageSize={50}
              total={catalogueStore.catalogueCount ?? 0}
              showSizeChanger={false}
              showQuickJumper={false}
              onChange={(
                page,

                // nextPageSize
              ) => {
                setCurrentPage(page);
                // setPageSize(nextPageSize);
                catalogueStore.GetCatalogueItems(
                  page,
                  // page_size: nextPageSize,
                );
              }}
            />
          </div>
          <CreateUpdateCatalogueItem />
        </div>
      )}
    </>
  );
};

export default observer(Catalogue);
